export default {"src":"/_next/static/media/logo.2b7687e0.svg","height":60,"width":148};